import { Phone, Clock } from 'lucide-react';
import { Card, CardHeader, CardBody } from '@/shared/components/ui/Card';
import { Spinner } from '@/shared/components/ui/Spinner';
import { EmptyState } from '@/shared/components/ui/EmptyState';
import { useSessionToday } from '../hooks/useCallCenter';
import { formatDuration } from '../constants';

export function SessionCard() {
  const { data, isLoading, isError } = useSessionToday();

  return (
    <Card>
      <CardHeader title="My Session Today" />
      <CardBody>
        {isLoading ? (
          <div className="flex justify-center py-6"><Spinner /></div>
        ) : isError ? (
          <EmptyState title="Failed to load session" description="Check your connection or try refreshing." />
        ) : (
          <div className="grid grid-cols-2 gap-3">
            <div className="flex items-center gap-3 rounded-card border border-outline bg-surface p-4">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-container text-on-primary-container">
                <Phone className="h-5 w-5" />
              </span>
              <div>
                <p className="text-display-sm font-semibold text-on-surface">{data?.calls?.total_calls ?? 0}</p>
                <p className="text-body-sm text-on-surface-variant">Calls today</p>
              </div>
            </div>
            <div className="flex items-center gap-3 rounded-card border border-outline bg-surface p-4">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-surface-variant text-on-surface-variant">
                <Clock className="h-5 w-5" />
              </span>
              <div>
                <p className="text-display-sm font-semibold text-on-surface">{formatDuration(data?.calls?.total_duration_sec ?? 0)}</p>
                <p className="text-body-sm text-on-surface-variant">Talk time</p>
              </div>
            </div>
          </div>
        )}
      </CardBody>
    </Card>
  );
}
